export default __webpack_public_path__ + "static/media/mountabu.84ce5b49.jpg";